<template>
  <b-modal
    id="inventoryUploadImages"
    title="Upload Image"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    size="lg"
    centered
    ref="ProductCroppa"
    @shown="values.croppa.refresh()">
    <div id="inventory-images-upload-container" class="border mx-auto">
      <croppa 
        v-model="values.croppa"
        @new-image-drawn="onNewImage"
        @zoom="onZoom"
        :width="700"
        :height="400"
        placeholder="Choose an Image"
        :accept="'.jpg, .png, .jpeg'"
        :show-remove-button="true"
        :placeholder-font-size="14"
        remove-button-color="#ff8828"
        :initial-image="initialValue">
      </croppa>
    </div>
    <div id="inventory-images-range-container" class="mx-auto mt-2">
      <input
        type="range"
        class="custom-range"
        id="customRange1"
        @input="onSliderChange"
        :min="values.sliderMin"
        :max="values.sliderMax"
        step=".001"
        v-model="values.sliderVal">
    </div>
    <div slot="modal-footer">
      <b-button
        variant="ghost"
        class="btn-cancel"
        style="margin-right: .25rem;"
        @click="closeModal">
        Cancel
      </b-button>
      <b-button
        variant="primary"
        style="margin-left: .25rem;"
        @click="generateBase64">
        Save
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "ProductCroppa",
  props: ["values", "initialValue"],
  methods: {
    onNewImage() {
      this.values.sliderVal = this.values.croppa.scaleRatio;
      this.values.sliderMin = this.values.croppa.scaleRatio / 2;
      this.values.sliderMax = this.values.croppa.scaleRatio * 2;
    },
    onSliderChange(evt) {
      const increment = evt.target.value;
      this.values.croppa.scaleRatio = +increment;
    },
    onZoom() {
      this.values.sliderVal = this.values.croppa.scaleRatio;
    },
    closeModal: function() {
      this.$emit("clearImage");
      this.$root.$emit("bv::hide::modal", "inventoryUploadImages");
    },
    generateBase64: function() {
      this.$store.commit("products/pushProductImage", {
        action: "create",
        image: this.values.croppa.generateDataUrl()
      });
      this.closeModal();
    }
  }
};
</script>
